import { setupSGWTConnect } from '@sgwt/connect-core';

import { getConfig } from '@/config/config.ts';

const sgConnectConfig = getConfig().app.sgconnect;
const overrideClientId = sessionStorage.getItem('E2eClientIdPersona');

if (overrideClientId && window.sgmeConfiguration.environment === 'deve2e') {
  sgConnectConfig.client_id = overrideClientId;
}

export const sgwtConnect = setupSGWTConnect(sgConnectConfig);

export function getAuthorizationHeader(): string | null {
  return sgwtConnect.getAuthorizationHeader();
}

export function getAuthorizationToken(): string | undefined {
  const authorizationHeader = getAuthorizationHeader();
  if (authorizationHeader == null) {
    return undefined;
  }
  return authorizationHeader.replace('Bearer ', '');
}

/**
 * @deprecated use useUserContext().currentUser.login
 */
export const getUserEmail = (): string | null => {
  const userEmail = sessionStorage.getItem('userEmail');
  const overrideMailUser = sessionStorage.getItem('OverrideMailUser');
  // @TODO need to check env
  // @FIXME getConfig().Email est default à chaine vide ?? ne fonctionne pas
  // Il faut revoir la condition, en attendant j'ai default sur null.
  return overrideMailUser ?? getConfig().userEmail ?? userEmail;
};
